import React, { PureComponent } from 'react';
import { USD } from '../../../libs/formatter';

import BalanceSellingFilters from './BalanceSellingFilters';

class BalanceSellingView extends PureComponent {
  render() {
    const {
      transactions,
      orderTotal,
      amountTotal,
      onFilterFormChange,
      filtersFormState,
      ordersCount,
      clients,
    } = this.props;

    if (!transactions || !orderTotal || !amountTotal) {
      return (<span>loading ...</span>);
    }
    return (
      <div>
        <BalanceSellingFilters
          clients={clients}
          filtersFormState={filtersFormState}
          onChange={onFilterFormChange}
        />
        <h1>Balance selling transactions</h1>
        <h4>
          <span style={{color: 'green'}}>{USD(orderTotal.positive)} ({USD(amountTotal.positive)}) </span>
          {' / '}
          <span style={{color: 'red'}}>{USD(orderTotal.negative)} ({USD(amountTotal.negative)})</span>
        </h4>
        <h5>
          Total Orders by state
          {': '}
          <span>{ordersCount.success} (Success) </span>
          {' / '}
          <span>{ordersCount.failure} (Failure) </span>
        </h5>
        <table className="amazonBalances">
          <thead>
            <tr>
              <th>date</th>
              <th>Account</th>
              <th>amount</th>
              <th>total</th>
            </tr>
          </thead>
          <tbody>
            {transactions.map((transaction, i) => (
              <tr key={i} className={transaction.amount < 0 ? 'fraud' : ''}>
                <td>{(new Date(transaction.created)).toLocaleString()}</td>
                <td>{transaction.username}</td>
                <td>{USD(transaction.amount / 100)}</td>
                <td>{USD(transaction.order.order_total / 100)}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    );
  }
}

export default BalanceSellingView;



// WEBPACK FOOTER //
// ./src/app/modules/WorkArea/BalanceSelling/BalanceSelling.view.js